import { 
  DocumentTextIcon, 
  ChartBarIcon, 
  BuildingOfficeIcon, 
  ClipboardDocumentCheckIcon
} from '@heroicons/react/24/outline';

interface InvestorFeature {
  title: string;
  description: string;
  icon: React.ElementType;
}

export const investorFeatures: InvestorFeature[] = [
  { 
    title: 'Quarterly Reports',
    description: 'Regular three-month performance updates and financial results for investors.',
    icon: DocumentTextIcon 
  },
  { 
    title: 'Financial Statements',
    description: 'Detailed records showing a company\'s income, expenses, and overall financial health.',
    icon: ChartBarIcon 
  },
  { 
    title: 'Property Documentation',
    description: 'Essential paperwork and records related to real estate holdings and assets.',
    icon: BuildingOfficeIcon 
  },
  { 
    title: 'Due Diligence Reports',
    description: 'Comprehensive investigations verifying a company\'s financial and operational status.',
    icon: ClipboardDocumentCheckIcon 
  }
] as const;